import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { ShippingServiceModelType, priceRangeTypes, serviceTypes } from '@teinor/erp/types/company/config/shipping/shippingCompany/shippingService'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { LittleModalCreateEdit} from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { getActiveCurrenciesDictionary, getAllGroupVats, getISOCurrencyMain } from '../../../../../../../../utils/reducers/getters'
import { useParams } from 'react-router'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
 export type ShippingServicePriceRangeTypes = typeof priceRangeTypes
 export type ShippingServiceTypes = typeof serviceTypes

interface ModalCreateConfigShippingServiceProps extends ModalEditComponentProps { }
 
const ModalCreateConfigShippingService: React.FC<ModalCreateConfigShippingServiceProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const groupVats = getAllGroupVats()
    const { ShippingCompanyId } = useParams()
    const priceRangeTypes: TwinDictionary = {
        0: { name: t('money', 'Dinero')},
        1: { name: t('weight', 'Peso')}
    }
    const serviceTypes: TwinDictionary = {
        0: { name: t('B2C', 'B2C')},
        1: { name: t('B2B', 'B2B')}
    }

    const fields: FormRender<ShippingServiceModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'serviceType',
                    label: t('type', 'Tipo'),
                    component: 'CustomSelect',
                    items: serviceTypes,
                    value: allRowData?.serviceType,
                    required: true,
                },
                {
                    name: 'CurrencyId',
                    label: t('currency', 'Moneda'),
                    component: 'CustomSelect',
                    items: getActiveCurrenciesDictionary(),
                    value: getISOCurrencyMain(),
                    required: true
                },
            ]
        },
        {
            cols: 2,
            elements: [
                {
                    name: 'priceVatIncluded',
                    label: t('priceVatIncluded', 'Precios con impuestos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true,
                },
                {
                    name: 'rangeVatIncluded',
                    label: t('rangeVatIncluded', 'Rangos con impuestos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true,
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    
                    items: groupVats || {},
                    value: allRowData?.GroupVatId,
                    required: true,
                },
                {
                    name: 'priceRangeType',
                    label: t('measureBy', 'Medir por'),
                    component: 'CustomSelect',
                    items: priceRangeTypes,
                    value: allRowData?.priceRangeType,
                    required: true,
                },
                {
                    name: 'ShippingCompanyId',
                    component: 'InputHidden',
                    value: ShippingCompanyId
                }
            ]
        }
    ]

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/shipping/shippingCompany/service/createShippingService'} translations={{
        title: t('createService', 'Crear servicio'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCreateConfigShippingService